export class CreativeSchedule {
  constructor(data) {
    const { startTime, endTime, creatives = [] } = data

    this.startTime = startTime
    this.endTime = endTime
    this.creatives = creatives.map(CreativeScheduleCreative.assign)
  }

  static assign(data) {
    return new CreativeSchedule(data)
  }
}

export class CreativeScheduleCreative {
  constructor(data) {
    const { id, ownerProfileId, creativeFolderId } = data

    this.id = id
    this.ownerProfileId = ownerProfileId
    this.creativeFolderId = creativeFolderId
  }

  static assign(data) {
    return new CreativeScheduleCreative(data)
  }
}
